// extracted by mini-css-extract-plugin
module.exports = {"message":"CountryValidationModal_message__1fzXe","message_override":"CountryValidationModal_message_override__2gauc"};